import React, { useEffect, useState } from "react";
import ThankYouHeader, {
  getThankYouIframeHeight,
} from "../../components/Layouts/ThankYouHeader/ThankYouHeader";
import { useFireOnceWhenReady } from "../../hooks/useFireOnceWhenReady";
import i18n, { t } from "i18next";
import AppStandardButton from "../../components/UI/AppButtons";
import BookingGetters from "../../store/onlineBooking/getters";
import { useSearchParams } from "react-router-dom";
import { TextResource } from "../../@types/DTO/AppSetting";
import { formatTheme } from "../../config/MuiColorThemes";
import { createTheme } from "@mui/material/styles";
import { BookingApi } from "../../API/Apis/BookingApi";
import { useTranslation } from "react-i18next";
import { BookingDetails } from "../../@types/Booking/bookingDetails";
import {
  trackPurchase,
  trackGoogleAdsConversion,
  readPurchaseItems,
  clearPurchaseItems,
  normalizeAmount,
} from "../../helpers/tracking";

export function BookingConfirmationPayPal() {
  const isUserLoggedin = localStorage.getItem("isUserLoggedin");
  const appSettings = BookingGetters.getAppSettings();
  const trackingCurrency = BookingGetters.getCurrency();
  const redirectWebCheckIn = appSettings?.redirectWebCheckIn;
  const bookingInformationFromRedux: BookingDetails =
    BookingGetters.getBookingDetails();
  const [bookingInformation, setBookingInformation] = useState<BookingDetails>(
    () => {
      const stored = sessionStorage.getItem("wireTransferBookingInfo");
      return stored ? JSON.parse(stored) : bookingInformationFromRedux;
    }
  );
  const scriptChannel = bookingInformation?.scriptChannel;
  const scriptChannelWindow = window.name;
  const scriptChannelSession = sessionStorage.getItem("scriptChannel");
  const HideOneButton =
    appSettings && appSettings?.hideButtonAtConfirmationPage;
  const hideHomeButtonFromNormalBooking =
    appSettings && appSettings?.hideHomeButtonFromNormalBooking;
  const hideHomeButtonFromReservedArea =
    appSettings && appSettings?.hideHomeButtonFromReservedArea;
  const showHomeButton =
    (isUserLoggedin !== "true" && !hideHomeButtonFromNormalBooking) ||
    (isUserLoggedin === "true" && !hideHomeButtonFromReservedArea);
  const [searchParams] = useSearchParams();
  const price = searchParams.get("amount");
  // const currentPriceToPay = sessionStorage.getItem("currentPriceToPay");
  const rawPrice = sessionStorage.getItem("currentPriceToPay");
  const currentPriceToPay =
    rawPrice && !isNaN(Number(rawPrice))
      ? parseFloat(Number(rawPrice).toFixed(2))
      : null;
  const dbId =
    searchParams.get("dbId") ||
    sessionStorage.getItem("wireTransferDbId") ||
    "";
  const ResId = searchParams.get("ResId");
  // console.log("paypalResId", ResId);
  const showResPrintButton = appSettings && appSettings?.showResPrintButton;

  useFireOnceWhenReady(
    appSettings,
    () => {
      const stored = readPurchaseItems();
      trackPurchase({
        transactionId: dbId,
        value: normalizeAmount(Number(price) || 0, "PAYPAL"),
        currency: stored?.currency || trackingCurrency || "EUR",
        items: stored?.items || [],
        coupon: stored?.coupon,
        paymentType: stored?.paymentType || "PAYPAL",
      });
      trackGoogleAdsConversion({
        enableDataLayer: appSettings?.enableDataLayer,
        event: appSettings?.gtagManagerEvent,
        sendTo: appSettings?.gTagManagerSendTo,
        currency: appSettings?.gTagManagerCurrency,
        value: appSettings?.enableGtagManagerValue ? Number(price) : null,
        transactionId: appSettings?.enableGTagManagerTranscationId
          ? dbId
          : null,
      });
      clearPurchaseItems();
    },
    [appSettings]
  );
  const lang = i18n.language;
  const { t: translate } = useTranslation();
  const textResource = BookingGetters.getTextResourceDetailsBasedOnLang();
  const data = textResource?.[lang]?.flatMap((item) => item.data || []) || [];
  const textResourcesLoaded = !!textResource?.[lang];
  const congratsLogo =
    data.find((item) => item.key === "booking_congrats_logo")?.body || "";
  const congratsIcon =
    data.find((item) => item.key === "booking_congrats_icon")?.body || "";

  const [congratsText, setCongratsText] = useState({
    title: "",
    message: "",
    note: "",
  });
  const [showDiscoverThankText, setShowDiscoverThankText] =
    useState<String>("");
  const [discoverButtonText, setDiscoverButtonText] = useState<String>("");
  useEffect(() => {
    const titleText = data.find(
      (item) => item.key === "booking_congrats_title"
    );
    const messageText = data.find(
      (item) => item.key === "booking_congrats_message"
    );
    const noteText = data.find((item) => item.key === "booking_congrats_note");
    setCongratsText({
      title: titleText?.body || t("booking_congrats_title"),
      message: messageText?.body || "",
      note: noteText?.body || t("booking_congrats_note"),
    });
    const discoverThankTextData = data.find(
      (item) => item.key === "showDiscoverExpThankYou"
    );
    setShowDiscoverThankText(discoverThankTextData?.body || "");

    const discoverButtonTextData = data.find(
      (item) => item.key === "discoverButtonText"
    );
    setDiscoverButtonText(
      discoverButtonTextData?.body || t("Discover the experiences")
    );
  }, [lang, textResource, translate]);

  const dynamicPalette = formatTheme();
  const dynamicTheme = createTheme(dynamicPalette);
  const primaryColor = dynamicTheme?.palette["primary"]?.main;
  const secondaryColor = dynamicTheme?.palette["secondaryColor"]?.main;
  const backgroundColor = dynamicTheme?.palette["backgroundColor"]?.main;
  const confirmationTextColor =
    dynamicTheme?.palette["confirmationTextColor"]?.contrastText;
  const secondPageBackgroundColor =
    appSettings && appSettings["secondPageBackgroundColor"];
  function requestParentResize() {
    window.parent.postMessage(
      {
        event_id: "iframeHeight",
        data: {
          iframeHeight: getThankYouIframeHeight(
            800,
            congratsLogo,
            congratsIcon
          ),
        },
      },
      "*"
    );
  }
  useEffect(() => {
    requestParentResize();
  }, [congratsLogo, congratsIcon]);

  const isAffiliateEnable = appSettings && appSettings?.enableAffiliate;
  // const scriptAffiliate = bookingInformation?.affiliateDetails?.code;
  const scriptAffiliateSession = sessionStorage.getItem("scriptAffiliate");

  const isVoucherCodeEnable = appSettings && appSettings?.showWebCodeInput;
  const scriptVoucherCodeSession = sessionStorage.getItem("scriptVoucherCode");

  const currencySymbol =
    appSettings?.defaultCurrency === "USD"
      ? "$"
      : appSettings?.defaultCurrency === "GBP"
      ? "£"
      : "€";

  const formatBookingDate = (dateVal: number | Date | undefined): string => {
    if (!dateVal) return "";
    const d = new Date(dateVal);
    if (isNaN(d.getTime())) return "";
    const locale =
      lang === "it"
        ? "it-IT"
        : lang === "fr"
        ? "fr-FR"
        : lang === "es"
        ? "es-ES"
        : "en-US";
    return d.toLocaleString(locale, {
      month: "long",
      day: "numeric",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const homepageHref =
    scriptChannelWindow || scriptChannel
      ? `/embed?scriptChannel=${
          scriptChannelSession || scriptChannelWindow || scriptChannel
        }`
      : isAffiliateEnable && scriptAffiliateSession
      ? `/embed?scriptAffiliate=${scriptAffiliateSession}`
      : isVoucherCodeEnable && scriptVoucherCodeSession
      ? `/embed?scriptVoucherCode=${scriptVoucherCodeSession}`
      : "/embed";

  const showWebCheckin = appSettings?.showNewWebCheckin;
  const webCheckinHref = `/booking/web-check-in-new?lang=${i18n.language}`;

  return (
    <section
      className="min-h-screen flex flex-col items-center justify-center py-10 px-4"
      style={{
        background: secondPageBackgroundColor || "#f0f2f5",
      }}
    >
      <div
        className="bg-white rounded-2xl shadow-lg w-full overflow-hidden px-8"
        style={{
          maxWidth: "480px",
          borderTop: `4px solid ${secondaryColor || "#E3007B"}`,
        }}
      >
        {/* Success header */}
        <ThankYouHeader
          title={congratsText?.title || t("booking_congrats_title")}
          message={congratsText?.message}
          note={congratsText?.note}
          logoUrl={congratsLogo}
          icon={congratsIcon}
          ready={textResourcesLoaded}
          primaryColor={primaryColor}
        >
          {dbId && (
            <div
              className="mt-5 px-8 py-1.5 rounded-md border-2 font-bold text-lg"
              style={{
                borderColor: primaryColor || "#22c55e",
                color: primaryColor || "#22c55e",
              }}
            >
              {dbId?.replace(/^([A-Za-z]+)(\d+)$/, "$1-$2")}
            </div>
          )}
        </ThankYouHeader>

        <hr className="border-gray-200" />

        {/* Itinerary */}
        <div className="py-5">
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "20px 1fr",
              gap: "0 16px",
            }}
          >
            {/* Pick-up row */}
            <div className="flex flex-col items-center">
              <div
                className="w-3 h-3 rounded-full mt-1 flex-shrink-0"
                style={{ backgroundColor: primaryColor || "#28B330" }}
              />
              <div className="w-px bg-gray-300 mt-1 flex-1" />
            </div>
            <div className="pb-5">
              <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-0.5">
                {t("Pick-up")}
              </p>
              <p className="text-sm font-semibold text-gray-900">
                {[
                  bookingInformation?.pickUpLocationDetails?.code,
                  bookingInformation?.pickUpLocationName,
                ]
                  .filter(Boolean)
                  .join(" - ")}
              </p>
              <p className="text-sm text-gray-500">
                {formatBookingDate(bookingInformation?.pickUpDateAndTime)}
              </p>
            </div>
            {/* Drop-off row */}
            <div className="flex justify-center pt-1">
              <div
                className="w-3 h-3 rounded-full flex-shrink-0"
                style={{ backgroundColor: secondaryColor || "#E3007B" }}
              />
            </div>
            <div>
              <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-0.5">
                {t("Drop-off")}
              </p>
              <p className="text-sm font-semibold text-gray-900">
                {[
                  bookingInformation?.dropOffLocationDetails?.code,
                  bookingInformation?.dropOffLocationName,
                ]
                  .filter(Boolean)
                  .join(" - ")}
              </p>
              <p className="text-sm text-gray-500">
                {formatBookingDate(bookingInformation?.dropOffDateAndTime)}
              </p>
            </div>
          </div>
        </div>

        <hr className="border-gray-200" />

        {/* Total amount */}
        {currentPriceToPay && (
          <div className="flex justify-between items-center py-4">
            <span className="text-sm text-gray-600">
              {t("Total rental amount")}
            </span>
            <span className="text-xl font-bold text-gray-900">
              {currencySymbol}
              {currentPriceToPay}
            </span>
          </div>
        )}

        {/* Action buttons */}
        <div className="flex gap-3 pb-8">
          {showHomeButton && (
            <AppStandardButton
              href={homepageHref}
              variant="contained"
              className="flex-1 py-4"
              style={{
                backgroundColor: primaryColor || "#22c55e",
                borderRadius: "10px",
                textTransform: "none",
                border: "none",
              }}
            >
              <span className="normal-case font-semibold text-sm text-white">
                Homepage
              </span>
            </AppStandardButton>
          )}
          {!redirectWebCheckIn
            ? !HideOneButton && (
                <AppStandardButton
                  href={showWebCheckin ? webCheckinHref : homepageHref}
                  variant="outlined"
                  className="flex-1 py-4"
                  style={{
                    borderRadius: "10px",
                    borderColor: secondaryColor || "#E3007B",
                    backgroundColor: "#fff0f5",
                    textTransform: "none",
                  }}
                >
                  <span
                    className="normal-case font-semibold text-sm"
                    style={{ color: secondaryColor || "#E3007B" }}
                  >
                    {showWebCheckin ? "Web Check-in" : "Dashboard"}
                  </span>
                </AppStandardButton>
              )
            : isUserLoggedin == "true" &&
              appSettings?.showWebCheckReservArea &&
              !HideOneButton && (
                <AppStandardButton
                  href={`/booking/web-check-in?lang=${i18n.language}`}
                  variant="outlined"
                  className="flex-1 py-4"
                  style={{
                    borderRadius: "10px",
                    borderColor: secondaryColor || "#E3007B",
                    backgroundColor: "#fff0f5",
                    textTransform: "none",
                  }}
                >
                  <span
                    className="normal-case font-semibold text-sm"
                    style={{ color: secondaryColor || "#E3007B" }}
                  >
                    Web Check-In
                  </span>
                </AppStandardButton>
              )}
          {showResPrintButton && (
            <AppStandardButton
              onClick={() => {
                BookingApi.getResPrint(ResId || "", lang).then((e) => {
                  const url = (e as any)?.file;
                  const linkSource = `data:application/pdf;base64,${url}`;
                  const downloadLink = document.createElement("a");
                  const fileName = "file.pdf";
                  downloadLink.href = linkSource;
                  downloadLink.download = fileName;
                  downloadLink.click();
                });
              }}
              variant="outlined"
              className="flex-1 py-4"
              style={{
                borderRadius: "10px",
                borderColor: primaryColor || "#22c55e",
                textTransform: "none",
              }}
            >
              <span
                className="normal-case font-semibold text-sm whitespace-nowrap"
                style={{ color: secondaryColor }}
              >
                Print Reservation
              </span>
            </AppStandardButton>
          )}
        </div>
      </div>

      {/* Discover experiences (optional, below card) */}
      {appSettings?.showDiscoverExpThankYou && (
        <div className="flex flex-col items-center gap-3 mt-6">
          <p
            className="text-base font-semibold text-center"
            style={{ color: secondaryColor }}
          >
            {showDiscoverThankText}
          </p>
          <AppStandardButton
            href="https://brevetermine.viaggiarerent.com/promo/civitatis/"
            variant="outlined"
            className="px-6 py-2"
            style={{
              borderRadius: "10px",
              borderColor: primaryColor,
            }}
          >
            <span
              className="normal-case text-sm"
              style={{ color: secondaryColor }}
            >
              {discoverButtonText}
            </span>
          </AppStandardButton>
        </div>
      )}
    </section>
  );
}
